import type { PriceListItem } from '@/types'

/**
 * One-off products (milk lockers, DF-230). Identified purely by the CRM
 * one-off-days field being set (> 0), never by SKU, name or category. They list
 * in the catalogue and the add picker like any product, but their "Add" routes
 * to the one-off landing page (2-week lead, no day choice, single line) instead
 * of the day-by-day add wizard. Shared so the Products page and the "Add a
 * product" modal behave identically.
 */
export const isOneOffProduct = (item: Pick<PriceListItem, 'one_off_days'>): boolean =>
  (item.one_off_days ?? 0) > 0

/** The landing-page path for a one-off: `/products/{sku}-{slug}`. The page
 *  resolves on the SKU; the slug is decorative for readable/shareable links. */
export const oneOffProductPath = (
  item: Pick<PriceListItem, 'product_number' | 'name'>
): string => {
  const slug = (item.name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
  return `/products/${item.product_number}${slug ? `-${slug}` : ''}`
}
